import { createIntl, createIntlCache, useIntl } from 'react-intl';
import { messages } from '../assets/translations/messages';

const cache = createIntlCache();

export class TranslationUtils {
    public static get(id: string, values?: { [key: string]: any }): string {
        const intl = useIntl();
        return intl.formatMessage({ id }, values);
    }

    public static translate(locale: string, id: string, values?: { [key: string]: string }) {
        const intl = createIntl({ locale, messages: messages[locale] as any }, cache);
        return intl.formatMessage({ id });
    }
}
